import styled from 'styled-components';

export const OfferMultiSelectStyle = styled.div`
  position: relative;
  width: 100%;

  &.is-disabled {
    opacity: 0.65;
    pointer-events: none;
  }

  .offer-multi-select__control {
    width: 100%;
    min-height: 2.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.375rem 0.625rem;
    background: #1f2733;
    border: 0.0625rem solid #ffffff26;
    border-radius: 0.625rem;
    cursor: pointer;
    text-align: left;
    color: #f6f8fb;
    transition: border-color 0.15s ease;

    &:hover {
      border-color: #4a5a72;
    }

    &:focus {
      outline: none;
      border-color: #007aff;
      box-shadow: 0 0 0 0.1875rem rgba(0, 122, 255, 0.2);
    }
  }

  &.is-open .offer-multi-select__control {
    border-color: #007aff;
    box-shadow: 0 0 0 0.1875rem rgba(0, 122, 255, 0.2);
  }

  &.is-error .offer-multi-select__control {
    border-color: #ff6b6b;
  }

  .offer-multi-select__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.375rem;
    flex: 1;
    min-width: 0;
    align-items: center;
  }

  .offer-multi-select__placeholder {
    color: #8b94a8;
    font-size: 0.8125rem;
    line-height: 1.4;
  }

  .offer-multi-select__chip {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    max-width: 10rem;
    padding: 0.125rem 0.5rem;
    background: #2d3a4d;
    border: 0.0625rem solid #4a5a72;
    border-radius: 0.375rem;
    color: #f6f8fb;
    font-size: 0.75rem;
    line-height: 1.25rem;
  }

  .offer-multi-select__chip--more {
    color: #c3cada;
    background: #243044;
  }

  .offer-multi-select__chip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .offer-multi-select__chip-remove {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    color: #c3cada;
    font-size: 0.875rem;
    line-height: 1;
    cursor: pointer;

    &:hover {
      color: #ffffff;
      background: rgba(255, 255, 255, 0.08);
    }
  }

  .offer-multi-select__caret {
    flex-shrink: 0;
    color: #9aa3b5;
    font-size: 0.75rem;
    padding: 0 0.125rem;
  }

  .offer-multi-select__panel {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 0.375rem);
    z-index: 50;
    background: #111823;
    border: 0.0625rem solid #ffffff4d;
    border-radius: 0.625rem;
    box-shadow: 0 1rem 2.5rem rgba(0, 0, 0, 0.5);
    overflow: hidden;
  }

  .offer-multi-select__search-row {
    padding: 0.625rem 0.625rem 0.375rem;
    border-bottom: 0.0625rem solid #ffffff14;
  }

  .offer-multi-select__search {
    width: 100%;
    height: 2.25rem;
    padding: 0 0.75rem;
    border-radius: 0.5rem;
    border: 0.0625rem solid #ffffff26;
    background: #1f2733;
    color: #f6f8fb;
    font-size: 0.8125rem;
    outline: none;

    &::placeholder {
      color: #8b94a8;
    }

    &:focus {
      border-color: #007aff;
    }
  }

  .offer-multi-select__actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.625rem;
    border-bottom: 0.0625rem solid #ffffff14;
  }

  .offer-multi-select__action {
    background: transparent;
    border: 0.0625rem solid #ffffff26;
    color: #c3cada;
    border-radius: 0.375rem;
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;

    &:hover {
      color: #ffffff;
      border-color: #007aff;
    }
  }

  .offer-multi-select__count {
    margin-left: auto;
    font-size: 0.6875rem;
    color: #8b94a8;
  }

  .offer-multi-select__list {
    max-height: 13.75rem;
    overflow-y: auto;
    padding: 0.375rem;
  }

  .offer-multi-select__empty {
    padding: 1rem 0.625rem;
    text-align: center;
    color: #8b94a8;
    font-size: 0.8125rem;
  }

  .offer-multi-select__option {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 0.5rem 0.625rem;
    border: none;
    border-radius: 0.5rem;
    background: transparent;
    color: #e9edf5;
    font-size: 0.8125rem;
    text-align: left;
    cursor: pointer;

    &:hover:not(.is-disabled) {
      background: #1f2733;
    }

    &.is-selected {
      background: #243044;
    }

    &.is-disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .offer-multi-select__check {
    width: 1.125rem;
    height: 1.125rem;
    flex-shrink: 0;
    border-radius: 0.25rem;
    border: 0.0625rem solid #4a5a72;
    background: #1f2733;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.6875rem;
    color: transparent;

    &.is-on {
      background: #007aff;
      border-color: #007aff;
      color: #ffffff;
    }
  }

  .offer-multi-select__option-label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
